<template>
  <div class="p-home">
    <div class="ban">
      <img class="banner-img" src="@/assets/img/banner.png" alt="" />
      <router-link to="/down" class="ban-btn"></router-link>
    </div>
    <!-- 最近直播 -->
    <div class="broad">
      <div class="main">
        <div class="main-title clear">
          <div class="fl provice color">最近直播</div>
          <div class="fr all" @click="toMore">全部直播 ></div>
        </div>
        <div class="broad-information">
          <div
            class="item"
            v-for="item in courseInformationList"
            :key="item.id"
            @click="downLoad(item.url)"
          >
            <div class="item-le">
              <div class="item-title">{{ item.course }}</div>
              <div class="item-tip">直播课资料下载</div>
            </div>
            <div class="item-ri">
              <img
                class="img"
                src="../../assets/img/icon_information.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="broad-items">
          <div class="item" v-for="item in broadList" :key="item.id">
            <div class="title">
              <div class="label">直播</div>
              <div class="time">{{ item.classDate }} {{ item.classTime }}</div>
            </div>
            <div class="name">{{ item.level }}{{ item.course }}</div>
            <div class="sub-tit">{{ item.chapter }}</div>
            <div class="down">
              距开始<span class="num">{{ item.countDownTime[0] }}</span
              >天<span class="num">{{ item.countDownTime[1] }}</span
              >: <span class="num">{{ item.countDownTime[2] }}</span
              >:
              <span class="num">{{ item.countDownTime[3] }}</span>
            </div>
            <div class="btns">
              <div
                class="down-load"
                @click="downLoad(item.docHref)"
                v-if="item.docHref"
              >
                <img
                  class="icon"
                  src="../../assets/img/icon/icon_down.png"
                  alt=""
                />
                <span class="text">下载课件</span>
              </div>
              <div v-else></div>
              <div style="display: flex">
                <el-popover
                  placement="top-start"
                  title="课前介绍"
                  width="200"
                  trigger="hover"
                  :content="item.chapterIntroduction"
                >
                  <div slot="reference" class="btn-introduce"></div>
                  <!-- <el-button slot="reference">hover 激活</el-button> -->
                </el-popover>
                <!-- <div slot="reference" class="btn-introduce"></div> -->
                <div class="btn" @click="toUrl(item, '直播')">
                  <div class="block">
                    <img
                      class="img"
                      src="../../assets/img/icon/icon_play.png"
                      alt=""
                    />
                  </div>
                  观看
                </div>
                <!-- <div class="btn join" @click="toUrl(item, '会议')">
                  <div class="block">
                    <img
                      class="img"
                      src="../../assets/img/icon/icon_join.png"
                      alt=""
                    />
                  </div>
                  加入
                </div> -->
              </div>
            </div>
          </div>
          <span class="no-data" v-if="broadList.length === 0"
            >暂无最近直播~</span
          >
        </div>
      </div>
    </div>
    <!-- 精选题库 -->
    <div class="infomation">
      <div class="main">
        <div class="main-title course-title clear">
          <div class="fl provice test">精选题库</div>
          <div class="fr select my-course">
            <span
              v-for="(item, i) in courseList"
              :key="i"
              class="select-item"
              :class="{ active: courseId === item.id }"
              @click="changeCourse(item)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
        <div class="question-bank">
          <!-- 顺序练习 -->
          <div class="item">
            <div class="item-tit">
              <div>顺序练习</div>
              <div class="tt">题型训练，对点特攻</div>
            </div>
            <div class="item-con">
              <div
                class="list"
                @click="toPaperDetail(item, '顺序练习')"
                v-for="item in practiceList"
                :key="item.id"
              >
                <div
                  class="list-status"
                  :class="
                    item.finishRate > 0 || item.finishCount > 0
                      ? item.finishRate < 100
                        ? 'n2'
                        : ''
                      : 'n1'
                  "
                >
                  {{ itemStatus(item) }}
                </div>
                <div class="list-name">{{ item.name }}</div>
                <div class="list-duration">
                  已完成{{ item.finishRate }}%
                  <span style="margin-left: 20px"
                    >共{{ item.subjectCount }}题</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 模拟考试 -->
          <div class="item">
            <div class="item-tit">
              <div>模拟测试</div>
              <div class="tt t2">佳期难得，好事多模</div>
            </div>
            <div class="item-con">
              <div
                class="list"
                @click="toPaperDetail(item, '模拟测试')"
                v-for="item in mockTestList"
                :key="item.id"
              >
                <div
                  class="list-status"
                  :class="
                    item.finishRate > 0
                      ? item.finishRate < 100
                        ? 'n2'
                        : ''
                      : 'n1'
                  "
                >
                  {{ itemStatus(item) }}
                </div>
                <div class="list-name">{{ item.name }}</div>
                <div class="list-duration">
                  已完成{{ item.finishRate }}%
                  <span style="margin-left: 20px"
                    >共{{ item.subjectCount }}题</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 历年真题 -->
          <div class="item">
            <div class="item-tit">
              <div>历年真题</div>
              <div class="tt t3">历年考卷合集</div>
            </div>
            <div class="item-con">
              <div
                class="list"
                @click="toPaperDetail(item, '历年真题')"
                v-for="item in oldQuestionList"
                :key="item.id"
              >
                <div
                  class="list-status"
                  :class="
                    item.finishRate > 0
                      ? item.finishRate < 100
                        ? 'n2'
                        : ''
                      : 'n1'
                  "
                >
                  {{ itemStatus(item) }}
                </div>
                <div class="list-name">{{ item.name }}</div>
                <div class="list-duration">
                  已完成{{ item.finishRate }}%
                  <span style="margin-left: 20px"
                    >共{{ item.subjectCount }}题</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 精品课 -->
    <div class="course">
      <div class="main">
        <div class="main-title clear">
          <div class="fl provice course">精品课</div>
        </div>
        <div class="course-items">
          <div
            @click="toCourseDetail(item)"
            class="item"
            v-for="item in courseList"
            :key="item.id"
          >
            <div class="top">
              <img class="img" :src="item.cover" alt="封面" />
            </div>
            <div class="bottom">
              <div class="name">
                {{ item.title }}
              </div>
              <div class="tip">
                {{ item.subtitle }}
              </div>
              <div class="num">{{ item.joinCount }}人已学习</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 最新资讯 -->
    <div class="infomation">
      <div class="main">
        <div class="main-title clear">
          <div class="fl provice">最新资讯</div>
          <div class="fr select">
            <el-select
              v-model="provinceData"
              placeholder="省份"
              class="Header-province"
              @change="handleProvinceChange"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
            <span
              v-for="(item, i) in labels"
              :key="i"
              class="select-item"
              :class="{ active: selectBabel === i }"
              @click="changeBabel(i)"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div class="info-items">
          <div class="item clear" v-for="item in articleList" :key="item.id">
            <div class="item-le">
              <img class="image" :src="item.cover" alt="" />
            </div>
            <div class="item-ri">
              <div>
                <div class="item-title">
                  {{ item.title }}
                </div>
                <div class="item-time">
                  <span>
                    {{ $Tools.time(item.publishDate, "yyyy-MM-dd hh:mm:ss") }}
                  </span>
                </div>
              </div>
              <div @click="toDetail(item.id)" class="item-detail">
                查看详情 >
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="kf-pagination"
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        @current-change="onCurrentChange"
      />
    </div>
    <practiceDialog
      ref="practiceDialog"
      :info="itemInfo"
      @submit="goPaperDetail('顺序练习')"
    />
    <mockDialog @submit="goPaperDetail" :info="itemInfo" ref="mockDialog" />

    <el-dialog
      :close-on-click-modal="false"
      title="直播"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <img style="width: 100%" :src="imgUrl" alt="直播图片" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
import FileUtil from "../../common/FileUtil";
import practiceDialog from "./practiceDialog";
import mockDialog from "./mockDialog";

export default {
  mixins: [page_mx],
  data() {
    return {
      provinceData: "浙江省",
      provinceList: ["浙江省", "安徽省"],
      dialogVisible: false,
      selectBabel: 0,
      courseId: "",
      broadList: [{ level: 111, countDownTime: [1, 2, 3, 4] }],
      courseInformationList: [],
      courseList: [],
      oldQuestionList: [],
      mockTestList: [],
      practiceList: [],
      itemInfo: {},
      imgUrl: "",
      // labels: ["报考资讯", "招生简章", "本地政策"],
    };
  },
  components: {
    practiceDialog,
    mockDialog,
  },
  computed: {
    itemStatus: () => {
      return (item) => {
        if (item.finishCount > 0) {
          if (item.finishRate < 100) {
            return "继续刷题";
          } else {
            return "已完成";
          }
        } else {
          return "未开始";
        }
      };
    },
  },
  methods: {
    // 初始化
    async init() {
      this.getLabels();
      this.getLists("浙江省", this.labels[this.selectBabel]);
      this.$api.cms.content.liveCourseSchedule_listCkbdLiveForClient
        .get()
        .then((res) => {
          // console.log(res);
          this.broadList = res.data.splice(0, 3);
          for (let i in this.broadList) {
            this.broadList[i].countDownTime = "";
            this.countDown(i);
          }
        });
      this.$api.cms.resource.course_listAdultExamCourseForClient
        .get()
        .then((res) => {
          this.courseList = res.data;
          if (res.data.length > 0) {
            this.courseId = res.data[0].id;
          }
          this.getOldQuestion();
          this.getMockTest();
          this.getPracticeList();
        });
      this.getCourseInformation();
    },
    // 顺序联系
    getPracticeList() {
      this.$api.cms.resource.paper_listPaperForClient
        .get({
          courseId: this.courseId,
          type: "顺序练习",
        })
        .then((res) => {
          this.practiceList = res.data;
        });
    },
    // 模拟测试
    getMockTest() {
      this.$api.cms.resource.paper_listPaperForClient
        .get({
          courseId: this.courseId,
          type: "模拟测试",
        })
        .then((res) => {
          this.mockTestList = res.data;
        });
    },
    // 历年真题
    getOldQuestion() {
      this.$api.cms.resource.paper_listPaperForClient
        .get({
          courseId: this.courseId,
          type: "历年真题",
        })
        .then((res) => {
          this.oldQuestionList = res.data;
        });
    },
    changeCourse(item) {
      this.courseId = item.id;
      this.getOldQuestion();
      this.getMockTest();
      this.getPracticeList();
    },
    getCourseInformation() {
      this.$api.cms.content.liveCourseInformation_listForClient
        .get()
        .then((res) => {
          this.courseInformationList = res.data;
        });
    },
    toDetail(id) {
      this.$router.push({
        path: "./detail",
        query: {
          id,
        },
      });
    },
    changeBabel(val) {
      this.selectBabel = val;
      this.getLists(this.provinceData, this.labels[this.selectBabel]);
    },
    handleProvinceChange() {
      this.getLists(this.provinceData, this.labels[this.selectBabel]);
    },
    toUrl(item, flag) {
      console.log(item, flag);
      this.dialogVisible = true;
      this.imgUrl = item.liveHref;
      // let now = Date.now();
      // if (now < item.liveStart || now > item.liveEnd)
      //   return this.$message.warning(
      //     `当前时间不可${flag === "会议" ? "加入" : "观看"}直播`
      //   );
      // this.$api.sms.study.studentLiveCourseSchedule_watchLive
      //   .put({
      //     liveCourseScheduleId: item.id,
      //   })
      //   .then(() => {
      //     window.open(flag === "会议" ? item.meetingHref : item.liveHref);
      //   });
    },
    downLoad(url) {
      if (!url) return this.$message("暂无资料下载");
      FileUtil.download(url);
    },
    countDown(i) {
      let item = this.broadList[i];
      this.broadList[i].countDownFn = setInterval(() => {
        if (this.countDownFun(item.countDownTime) == "倒计时结束") {
          clearInterval(this.broadList[i].countDownFn); //清除定时器
        } else {
          item.countDownTime = this.countDownFun(item.liveStart);

          this.$set(
            this.broadList,
            item.countDownTime,
            this.countDownFun(item.liveStart)
          );
        }
      }, 1000);
    },
    countDownFun(time) {
      let startTime = new Date(); //当前时间
      let end = new Date(time); //结束时间
      let result = parseInt((end - startTime) / 1000); //计算出豪秒
      let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
      let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
      let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
      let s = parseInt(result % 60);
      //当倒计时结束时，改变内容
      if (result <= 0) {
        return "倒计时结束";
      }

      return [
        String(d).padStart(2, "0"),
        String(h).padStart(2, "0"),
        String(m).padStart(2, "0"),
        String(s).padStart(2, "0"),
      ];
    },
    toMore() {
      this.$router.push({
        path: "/broast",
      });
    },
    toPaperDetail(row, paperType) {
      this.itemInfo = row;
      if (paperType === "顺序练习") {
        this.$refs.practiceDialog.openDialog();
      } else {
        if (row.finishRate == 100) {
          this.goPaperDetail(paperType);
        } else {
          this.$nextTick(() => {
            this.$refs.mockDialog.openDialog(paperType, row.id);
          });
        }
      }
    },
    goPaperDetail(paperType, b) {
      this.$router.push({
        path: "/paper_detail",
        query: {
          courseId: this.itemInfo.courseId,
          exerciseId:
            this.itemInfo.finishRate == 100 || b == 100
              ? ""
              : this.itemInfo.latestExerciseId,
          paperType,
          type: "测试",
          name: this.itemInfo.name,
          paperId: this.itemInfo.id,
        },
      });
    },
    toCourseDetail(row) {
      this.$api.cms.resource.course_detailsAdultExamCourseForClient
        .get({
          id: row.id,
        })
        .then((res) => {
          this.$router.push({
            path: "/course_detail",
            query: {
              courseId: row.id,
              lastKnowledgeId: res.data.lastKnowledgeId,
            },
          });
        });
    },
  },
  async created() {},

  beforeDestroy() {
    this.broadList.forEach((item) => {
      clearInterval(item.countDownFn);
    });
  },
};
</script>
<style lang="less" scope>
.ban {
  position: relative;
  &-btn {
    position: absolute;
    left: 50%;
    bottom: 90px;
    width: 240px;
    margin-left: -120px;
    height: 70px;
  }
}
.clear:after {
  content: "";
  height: 0;
  display: block;
  clear: both;
}

.main {
  width: 1160px;
  margin: 80px auto;
  &-title {
    .provice {
      position: relative;
      padding-left: 18px;
      color: #333;
      font-size: 24px;
      font-weight: 600;
    }
    .provice::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      z-index: -1;
      width: 38px;
      height: 38px;
      background-color: #cfecff;
      border-radius: 50%;
      opacity: 0.6;
    }
    .provice.color::before {
      background-color: #ffe4e4;
    }
    .provice.course::before {
      background-color: #fff1c2;
    }
    .provice.test::before {
      background-color: #d7f4d9;
    }
    .all {
      font-size: 14px;
      color: #666;
      cursor: pointer;
    }
    .toggle {
      position: absolute;
      top: 50%;
      width: 0px;
      height: 0px;
      border-top: 20px solid #333;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
    }
    .select {
      &-item {
        display: inline-block;
        margin-left: 20px;
        margin-bottom: 10px;
        padding: 0 10px;
        text-align: center;
        line-height: 28px;
        height: 28px;
        background: #f2f2f2;
        border-radius: 30px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
      &-item.active {
        background: #00b861;
        color: #fff;
      }
    }
    .select.my-course {
      width: 1000px;
      display: flex;
      flex-wrap: wrap;
      justify-content: right;
    }
  }
  &-title.course-title {
    display: flex;
    justify-content: space-between;
  }
  .broad-information {
    display: flex;
    padding-top: 30px;
    flex-wrap: wrap;
    .item {
      margin-right: 16px;
      margin-top: 20px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 376px;
      height: 100px;
      background: #fff;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.1);
      border-radius: 8px;
      cursor: pointer;
      box-sizing: border-box;
      &-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 25px;
      }
      &-tip {
        padding-top: 10px;
        font-size: 14px;
        color: #348cff;
        line-height: 20px;
      }
      &-ri {
        .img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .item:nth-child(3n) {
      margin-right: 0;
    }
  }
  .broad-items {
    position: relative;
    margin-top: 20px;
    height: 180px;
    display: flex;

    .no-data {
      font-size: 20px;
      color: #999;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .item {
      margin-right: 16px;
      padding: 16px;
      width: 376px;
      height: 206px;
      background: #fff;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.1);
      border-radius: 8px;
      box-sizing: border-box;

      .title {
        display: flex;
        .label {
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 20px;
          background: rgba(65, 204, 138, 0.1);
          border-radius: 4px;
          font-size: 12px;
          color: #00b861;
        }
        .time {
          font-size: 12px;
          color: #666;
        }
      }

      .name {
        margin-top: 10px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .sub-tit {
        padding-top: 8px;
        font-size: 14px;
        line-height: 18px;
        color: #666;
      }
      .down {
        margin-top: 16px;
        display: flex;
        align-items: center;
        .num {
          margin: 0 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          background: #333333;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          color: #fff;
        }
      }
      .btns {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .down-load {
          cursor: pointer;
          display: flex;
          align-items: center;
        }
        .icon {
          width: 16px;
          height: 16px;
        }
        .text {
          margin-left: 6px;
          color: #348cff;
          cursor: pointer;
        }
        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 68px;
          height: 28px;
          background: rgba(0, 184, 97, 0);
          border-radius: 32px;
          border: 1px solid #00b861;
          color: #00b861;
          cursor: pointer;
          .block {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            .img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .btn.join {
          margin-left: 10px;
          width: 68px;
          height: 28px;
          background: #00b861;
          border-radius: 32px;
          border: 1px solid #00b861;
          color: #fff;
        }
        .btn-introduce {
          margin-right: 10px;
          width: 94px;
          height: 28px;
          cursor: pointer;
          background-image: url(../../assets/img/btn.png);
          background-repeat: no-repeat;
        }
      }
    }
  }
  .course-items {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-top: 30px;
      margin-right: 20px;
      width: 275px;
      height: 290px;
      background: #fff;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.1);
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
      .top {
        height: 155px;
        border-radius: 8px 8px 0px 0px;
        .img {
          width: 100%;
          height: 100%;
          border-radius: 8px 8px 0px 0px;
        }
      }
      .bottom {
        padding: 16px;
        .name {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .tip {
          padding-top: 8px;
          font-size: 12px;
          color: #999999;
          height: 36px;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .num {
          padding-top: 16px;
          font-size: 12px;
          color: #bebebe;
        }
      }
    }
    .item:nth-child(4n) {
      margin-right: 0;
    }
  }
  .info-items {
    margin-top: 30px;
    .item {
      display: flex;
      margin-top: 30px;
      padding-bottom: 30px;
      border-bottom: 2px solid #eee;
      &-le {
        margin-right: 40px;
        .image {
          width: 380px;
          height: 240px;
          border-radius: 10px;
        }
      }
      &-ri {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
      }
      &-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 32px;
        color: #333;
      }

      &-time {
        font-size: 20px;
        color: #999;
        margin-top: 30px;
      }

      &-detail {
        width: 144px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #333;
        border-radius: 4px;
        cursor: pointer;
      }

      &-detail:hover {
        border-color: #00b861;
        color: #00b861;
      }
    }
    .item:last-child {
      border: none;
    }
  }
  .question-bank {
    padding-top: 34px;
    display: flex;

    .item {
      margin-right: 16px;
      padding: 20px 16px;
      width: 376px;
      height: 278px;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.1049);
      box-sizing: border-box;
      &-tit {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: #333;
        .tt {
          font-size: 14px;
          padding-left: 16px;
          color: #3480ff;
          font-weight: normal;
        }
        .t2 {
          color: #00b861;
        }
        .t3 {
          color: #ffba27;
        }
      }
      &-con {
        padding-right: 8px;
        padding-top: 16px;
        height: 200px;
        overflow-y: auto;
        .list {
          position: relative;
          padding: 8px;
          margin-bottom: 8px;
          height: 60px;
          box-sizing: border-box;
          cursor: pointer;
          &-status {
            position: absolute;
            top: 0;
            right: 0;
            width: 60px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            border-radius: 0px 8px 0px 12px;
            background: linear-gradient(112deg, #3bdf8b 5%, #0bc25f 95%),
              #d9dce4;
          }
          &-status.n1 {
            background: #d9dce4;
          }
          &-status.n2 {
            background: linear-gradient(101deg, #ffc92b 1%, #ff9e11 93%),
              #d9dce4;
          }
          &-name {
            width: 300px;
            font-size: 14px;
            color: #333;
          }
          &-duration {
            padding-top: 8px;
            font-size: 12px;
            color: #a8aab8;
          }
        }
      }
    }
    .item:last-child {
      margin-right: 0;
    }
  }
}

.banner-img {
  width: 100%;
}
</style>
